import React from 'react';
import { connect } from 'react-redux';
import Selector from '../../components/Selector';
import IntentName from '../../components/IntentName';

const onFilter = (name, val) => name.toLowerCase().indexOf(val) !== -1;
const renderItem = (name) => <IntentName name={name} />;

export default connect(
    state => ({
        data: Object.values(state.intents).map(el => el.name),
        onFilter,
        renderItem
    }),
    {
    }
)(Selector);